/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeStaffEditCtrl
 */
angular.module('mercury.modules.time.staff')
.controller('TimeStaffEditCtrl', ["$filter", "ngToast", "$q", "ReportPosStaff", "$scope", "$state", "$stateParams", "TimeStaff", "TimeRoles", "title", "userinfo", "PreviousState", function($filter, ngToast, $q,
  ReportPosStaff, $scope, $state, $stateParams, TimeStaff, TimeRoles, title,
  userinfo, PreviousState) {

  $scope.currentTab = 'basic';
  var formControllers = {};
  $scope.noRolesError = false;
  $scope.fullPayroll = userinfo.companyPreferenceGet('features.payroll') == '1';

  /**
   * Remove hourlyrate from the role if it has not been set.
   * It is null if the user does not have payroll permissions.
   * Null hourlyrate field will break the request when it reaches the backend
   * See LOADED-1226
   */
  function removeHourlyRate() {
    $scope.staff.memberRoles.forEach(function(role) {
      if (role.hourlyRate === null) {
        delete role.hourlyRate;
      }
    });
  }

  var loadingPromises = {
    posStaff: ReportPosStaff.getAllActiveUnlinked(),
    roles: TimeRoles.getAllActive()
  };

  if ($stateParams.id) {
    title.set('Edit');
    loadingPromises.staff = TimeStaff.get($stateParams.id);
  } else {
    title.set('Add Staff Member');
  }

  $scope.loading = $q.all(loadingPromises);
  $scope.loading.then(function(result) {
    $scope.posStaff = result.posStaff;
    $scope.roles = result.roles;

    if (result.staff) {
      titleString = (result.staff.firstName != null) ? result.staff.firstName : '';
      titleString = (result.staff.lastName != null) ? titleString + ' ' + result.staff.lastName : titleString;

      title.set('Edit ' + titleString);

      $scope.staff = result.staff;

      if (!userinfo.companyHasPermission('Salary')) {
        // The active rate isn't provided without salary permisssion. Set to zero so the
        // input directive doesn't complain.
        $scope.staff.activeRemuneration.rate = 0;
      }
    } else {
      $scope.staff = {
        showInRoster: true,
        datestampStarted: moment().format(),
        memberRoles: [{
          hourlyRate: 0
        }],
        activeRemuneration: {
          type: 0,
          rate: 0
        },
        paytypes: [],
        rules: []
      };

      if ($scope.roles.length > 0) {
        $scope.staff.defaultRoleId = $scope.roles[0].id;
        $scope.staff.memberRoles[0].roleId = $scope.roles[0].id;
      }

      if ($stateParams.posIdentifier) {
        var posStaff = $filter('filter')($scope.posStaff, {posIdentifier: $stateParams.posIdentifier})[0];

        if (posStaff) {
          $scope.applyPosStaffDetails(posStaff);
        }
      }

      $scope.noRolesError = ($scope.roles.length === 0);
    }
  }, function() {
    $state.go('Time.StaffList');
  });

  // Update the fields of the staff member to match the POS Staff member.
  $scope.applyPosStaffDetails = function(posStaff) {
    $scope.staff.posIdentifier = posStaff.posIdentifier;
    $scope.staff.posStaffName = posStaff.firstName + ' ' + (posStaff.lastName || '');
    $scope.staff.firstName = posStaff.firstName;
    $scope.staff.lastName = posStaff.lastName;

    var posRole = $filter('filter')($scope.roles, {posIdentifier: posStaff.roleIdentifier})[0];

    // Clean up any exisiting temp POS roles from the roles select
    angular.forEach($scope.roles, function(role, roleIndex) {
      if (!role.id) {
        $scope.roles.splice(roleIndex, 1);

        // The default role isn't a temp POS role, but since one was in the roles
        // select, search the member roles for temp POS roles
        if ($scope.staff.defaultRoleId) {
          angular.forEach($scope.staff.memberRoles, function(memberRole, index) {
            if (!memberRole.roleId) {
              $scope.staff.memberRoles.splice(index, 1);
            }
          });
        }
      }
    });

    // The POS Staff POS Role doesn't already exist in the company database so
    // add it as a temp POS role that will be created during the save process
    if (!posRole) {
      if (posStaff.roleIdentifier) {
        posRole = {
          posIdentifier: posStaff.roleIdentifier,
          name: posStaff.roleName
        };

        $scope.roles.push(posRole);
      } else {
        // if we don't have a role posIdentifier then try to just assign any role
        // failing that, return with no role set, and we'll present the no roles error to the user
        if ($scope.roles.length === 0) {
          return;
        }

        posRole = $scope.roles[0];
      }
    }

    // Update the default role to be the POS role.
    angular.forEach($scope.staff.memberRoles, function(memberRole) {
      if (memberRole.roleId == $scope.staff.defaultRoleId) {
        memberRole.hourlyRate = posStaff.hourlyRate;
        memberRole.roleId = posRole.id;

        if (!posRole.id) {
          memberRole.role = posRole;
        }
      }
    });

    $scope.staff.defaultRoleId = posRole.id;
  };

  $scope.create = function() {
    if ($scope.validateForms() === false) {
      ngToast.dismiss();
      ngToast.danger('Please fix invalid fields.');
      return;
    }

    $scope.creating = TimeStaff.create($scope.staff);
    $scope.creating.then(function() {
      $state.go('Time.StaffList');
    });
  };

  /**
   * Send the changes to the server and return to the staff list page.
   */
  $scope.save = function() {
    //If this isn't the inline form, there will be a formController in scope.
    //Ensure this form is valid before completing the save.
    if ($scope.validateForms() === false) {
      ngToast.dismiss();
      ngToast.danger('Please fix invalid fields.');
      return;
    }

    removeHourlyRate();

    $scope.saving = TimeStaff.update($scope.staff);
    $scope.saving.then(function() {
      $state.go('Time.StaffList');
    });
  };

  $scope.deleteStaff = function() {
    if ($scope.validateForms() === false) {
      ngToast.dismiss();
      ngToast.danger('Please fix invalid fields.');
      return;
    }

    removeHourlyRate();

    $scope.deleting = TimeStaff.remove($scope.staff);
    $scope.deleting.then(function() {
      $state.go('Time.StaffList');
    });
  };

  $scope.undeleteStaff = function() {
    if ($scope.validateForms() === false) {
      ngToast.dismiss();
      ngToast.danger('Please fix invalid fields.');
      return;
    }

    removeHourlyRate();

    $scope.restoring = TimeStaff.restore($scope.staff);
    $scope.restoring.then(function() {
      $state.go('Time.StaffList');
    });
  };

  // Function to allow the sub controllers to register forms that will be
  // varlidated before save
  $scope.registerForm = function(tab, form) {
    formControllers[tab] = form;
  };

  // Iterate the registered formControllers to ensure all staff details are valid.
  $scope.validateForms = function() {
    var isValid = true;
    angular.forEach(formControllers, function(formCtrl, tab) {
      formCtrl.$setSubmitted();
      if (formCtrl.$invalid) {
        if (isValid) {
          $scope.changeTab(tab);
        }
        isValid = false;
      }
    });
    return isValid;
  };

  $scope.changeTab = function(newTab) {
    $scope.currentTab = newTab;
  };

  $scope.handleCancel = function() {
    if ($stateParams.from && $stateParams.from === 'clockin:staffreport') {
      $state.go('Time.ClockStaffreport', PreviousState.params);
    } else {
      $state.go('Time.StaffList');
    }
  };
}]);
